import { useI18n } from '@cascade/react/i18n';
import { Loading, Text } from '@cascade/ui-library';
import clsx from 'clsx';
import { useId } from 'react';
import classes from './CardLayout.module.scss';
import { Header } from './header/index.ts';
import { Hero } from '#components/hero/index.ts';
import { useLayout } from '#layout/Layout.context.ts';
import type { TCardLayoutProps } from '#layout/Layout.types.ts';
import { Footer } from '#layout/shared/footer/index.ts';

export const CardLayout = ({
  title,
  subtitle,
  isLoading = false,
  width = 'narrow',
  children,
}: TCardLayoutProps) => {
  const { translate } = useI18n();
  const { isRegular } = useLayout();
  const titleId = useId();

  const isScrollable = isRegular && !isLoading;

  return (
    <div className={clsx(classes['card-layout'], classes[width])}>
      <Hero />
      <Header />
      <main className={classes.frame}>
        <div className={classes.scroller}>
          <div className={classes.card}>
            <div className={classes.heading}>
              <Text
                id={titleId}
                type='h1'
                weight='semibold'
                compact
                content={title}
                className={classes.title}
              />
              {subtitle ? (
                <Text type='body-2' color='text-60' content={subtitle} />
              ) : null}
            </div>
            <div
              className={classes.body}
              role='region'
              aria-labelledby={titleId}
              tabIndex={isScrollable ? 0 : undefined}
            >
              {isLoading ? <Loading contain label={title} /> : children}
            </div>
            <Footer />
          </div>
        </div>
        <div className={classes.usp} aria-hidden='true'>
          <Text
            type='display'
            weight='semibold'
            color='text-white'
            content={translate('authentication.usp')}
          />
        </div>
      </main>
    </div>
  );
};
